/**
 * Cart API Bridge for Horizon theme
 *
 * Third-party cart apps (e.g. slidecarthq) bypass Horizon's event system.
 * This script intercepts both fetch AND XMLHttpRequest calls to cart endpoints,
 * then updates the cart badge DOM directly (Section Rendering approach) and
 * dispatches Horizon's 'cart:update' event as fallback.
 *
 * The fallback event is skipped when the theme itself already announced the
 * request (product-form, sf-stack-save, …): those events carry the fresh
 * section HTML, while this one doesn't. A second, sections-less 'cart:update'
 * makes cart-items-component re-render the whole header section right after
 * the cart drawer's showModal(); that morph can move the open <dialog> out of
 * the top layer, and sf-lp-cart-drawer-guard.js then closes the drawer.
 */
(function () {
  const CART_ENDPOINTS = /\/cart\/(add|change|update|clear)\.js/;
  const originalFetch = window.fetch;
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  // When the theme last dispatched its own 'cart:update' (performance.now()).
  let lastThemeCartUpdateAt = -1;

  document.addEventListener('cart:update', function (event) {
    if (event.detail && event.detail.sourceId === 'sf-cart-bridge') return;
    lastThemeCartUpdateAt = performance.now();
  });

  /**
   * @param {number} requestStartedAt - performance.now() when the cart request was sent
   */
  function updateCartCount(requestStartedAt) {
    originalFetch.call(window, '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;

        document.querySelectorAll('[ref="cartBubbleCount"]').forEach(function (el) {
          el.textContent = count;
        });
        document.querySelectorAll('[ref="cartBubble"]').forEach(function (el) {
          if (count === 0) {
            el.setAttribute('hidden', '');
          } else {
            el.removeAttribute('hidden');
          }
        });

        // The theme already dispatched its own event for this request.
        if (lastThemeCartUpdateAt >= requestStartedAt) return;

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'sf-cart-bridge',
              data: {
                source: 'sf-cart-bridge',
                itemCount: count,
              },
            },
          })
        );
      })
      .catch(function () { /* silent */ });
  }

  /* ---- Intercept fetch ---- */
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    if (!CART_ENDPOINTS.test(url)) {
      return originalFetch.apply(this, args);
    }

    const requestStartedAt = performance.now();

    return originalFetch.apply(this, args).then(function (response) {
      if (response.ok) setTimeout(updateCartCount, 200, requestStartedAt);
      return response;
    });
  };

  XMLHttpRequest.prototype.open = function (method, url) {
    this._sfCartUrl = url;
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this._sfCartUrl && CART_ENDPOINTS.test(this._sfCartUrl)) {
      const requestStartedAt = performance.now();

      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          setTimeout(updateCartCount, 200, requestStartedAt);
        }
      });
    }
    return originalXHRSend.apply(this, arguments);
  };
})();
